// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2f-uL","subheader":"ReorderModal_subheader__2sPw1","listWrap":"ReorderModal_listWrap__Hq4z-"};